import React from "react";
import { HOME } from "@/constants/testIds";
import { Eye, MessageSquareOff, Timer, Zap, Sparkles, LayoutGrid } from "lucide-react";

export const BusinessOutcomes = () => {
  const outcomes = [
    { icon: Eye,             title: "Complete Shipment Visibility", body: "End-to-end transparency — origin to delivery, surfaced for every stakeholder." },
    { icon: MessageSquareOff,title: "Fewer Follow-Ups",              body: "Replace the 'where is it?' Slack thread with a live, shared source of truth." },
    { icon: Timer,           title: "Real-Time ETA",                 body: "AI-adjusted arrival times reduce planning errors and warehouse waste." },
    { icon: Zap,             title: "Faster Decisions",              body: "Context arrives before exceptions do — act in minutes, not days." },
    { icon: Sparkles,        title: "Operational Transparency",      body: "Auditable trail of every milestone, document and alert across the team." },
    { icon: LayoutGrid,      title: "One Workspace",                 body: "One login, one workflow — tracking sits inside the import operating system." },
  ];

  return (
    <section
      id="outcomes"
      data-testid={HOME.outcomesSection}
      className="relative py-24 md:py-32 border-y border-ink-10"
    >
      <div className="container-narrow">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 max-w-5xl">
          <div>
            <div className="text-[11px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
              07 — Business Outcomes
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold ink leading-[1.05] text-balance">
              Outcomes the leadership team will actually feel.
            </h2>
          </div>
          <p className="text-[14.5px] ink-soft max-w-md">
            Visibility translates into faster cycles, fewer escalations and a calmer
            import operation across procurement, finance and logistics.
          </p>
        </div>

        <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {outcomes.map((o, idx) => {
            const I = o.icon;
            return (
              <li
                key={o.title}
                data-testid={HOME.outcomeCard}
                className="group relative rounded-2xl bg-white border border-ink-10 p-6 overflow-hidden transition-all hover:translate-y-[-2px]"
              >
                <span className="absolute right-5 top-5 text-[10.5px] font-mono ink-soft opacity-60">
                  0{idx + 1}
                </span>
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-emerald/10 text-emerald mb-4 group-hover:scale-105 transition-transform">
                  <I className="h-5 w-5" />
                </span>
                <h3 className="font-display text-[17px] font-semibold ink mb-2">{o.title}</h3>
                <p className="text-[13.5px] ink-soft leading-relaxed">{o.body}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
